/** @format */

export const DEFAULT_TEST_ID = 'model-recommendations-carousel';
